export const ItemVacio = (codTipoObjeto, idPadre) => {
  return {
    id: null,
    codTipoObjeto: codTipoObjeto,
    idObjeto: idPadre,
    tipoInformacion: null,
    fuenteInformacion: null,
    numeroFuente: null,
    anioFuente: null,
    mesFuente: null,
    diaFuente: null,
    detalle: null,
    observaciones: null,
  };
};

export const saveItem = (item) => {
  return {
    id: item.id,
    codTipoObjeto: item.codTipoObjeto
      ? item.codTipoObjeto
      : item.tipoObjeto && item.tipoObjeto.codigo,
    idObjeto: item.idObjeto,
    codTipoInformacion: item.tipoInformacion && item.tipoInformacion.codigo,
    idFuenteInformacion: item.fuenteInformacion && item.fuenteInformacion.id,
    numeroFuente: item.numeroFuente,
    anioFuente: item.anioFuente,
    mesFuente: item.mesFuente,
    diaFuente: item.diaFuente,
    detalle: item.detalle,
    observaciones: item.observaciones,
  };
};
